import { useState } from "react";
import logo from "../assets/logo/Logo.svg";
import eye from "../assets/images/icons/eye.svg";
import eyeslash from "../assets/images/icons/eye-slash.svg";
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import Carousel from "../components/carousel/logincarousel";
import loginbanner from "../assets/images/login-banner.png";
import loginbannertwo from "../assets/images/login-banner-2.png";
import loginbannerthree from "../assets/images/login-banner-3.png";
import loginbannerfour from "../assets/images/login-banner-4.png";
import loginbannersm from "../assets/images/login-banner-sm.png";
import bannerlayout from "../assets/images/banner-layout.png";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
export default function ResetPassword() {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [passwordError, setPasswordError] = useState(""); // New error state for password validation
  const [confirmPasswordError, setConfirmPasswordError] = useState(""); // Error for confirm password
  const [isSubmitting, setIsSubmitting] = useState(false); // Prevent duplicate submits
  const [passwordCriteria, setPasswordCriteria] = useState({
    minLength: false,
    alphanumeric: false,
    specialChar: false,
  });
  const navigate = useNavigate();

  // Carousel login
  let slides = [
    loginbanner,
    loginbannertwo,
    loginbannerthree,
    loginbannerfour
  ];
  let slidessm = [
    loginbannersm,
    loginbannersm,
    loginbannersm,
    loginbannersm,
  ];

  // ✅ Password validation logic
  const validatePassword = (value) => {
    setPassword(value);

    const criteria = {
      minLength: value.length >= 8,
      alphanumeric: /[a-zA-Z]/.test(value) && /[0-9]/.test(value),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(value),
    };

    setPasswordCriteria(criteria);

    if (!criteria.minLength || !criteria.alphanumeric || !criteria.specialChar) {
      setPasswordError("Password must meet all the criteria.");
    } else {
      setPasswordError("");  // Clear error if criteria are met
    }
  };

  const validateConfirmPassword = (value) => {
    setConfirmPassword(value);

    if (!value) {
      setConfirmPasswordError("Confirm password is required.");
    } else if (value !== password) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setConfirmPasswordError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Prevent duplicate submissions
    if (isSubmitting) return;
    setIsSubmitting(true);
    setError("");

    // ✅ Check all criteria are met before submission
    if (!passwordCriteria.minLength || !passwordCriteria.alphanumeric || !passwordCriteria.specialChar) {
      setIsSubmitting(false);
      toast.error("⚠️ Password must meet all the criteria below.", {
        position: "top-right",
        autoClose: 3000,
        style: { backgroundColor: "#ff4d4f", color: "#fff", fontWeight: "bold" }
      });
      return;
    }

    // Final validation before submission
    if (!password) {
      setIsSubmitting(false);
      setPasswordError("New password is required.");
      return;
    }
    if (!confirmPassword) {
      setIsSubmitting(false);
      setConfirmPasswordError("Confirm password is required.");
      return;
    }
    if (password !== confirmPassword) {
      setIsSubmitting(false);
      setConfirmPasswordError("Passwords do not match.");
      return;
    }
    // Retrieve OTP and Token from sessionStorage
    const otpreceived = sessionStorage.getItem("otp");
    const token = sessionStorage.getItem("resetToken");

    if (!otpreceived || !token) {
      setIsSubmitting(false);
      setError("OTP or token is missing.");
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/auth/reset-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            otp: otpreceived, // Ensure the correct OTP is provided dynamically
            password: password,
            token: token
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        // alert("Password reset successful!");
        toast.success("✅ Password reset successful! Redirecting to login...");

        // ✅ Store user details in sessionStorage
        if (data.result?.userDoc) {
          sessionStorage.setItem("userDoc", JSON.stringify(data.result.userDoc));
          localStorage.setItem("userDoc", JSON.stringify(data.result.userDoc));
          console.log("userDoc stored in sessionStorage:", data.result.userDoc);
        }

        navigate("/login"); // Redirect to homepage
      } else {
        setError(data.message || "Password reset failed.");
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="login">
      <div className="container min-h-screen flex">
        {/* Left side image */}
        <div className="hidden lg:block lg:w-1/2">
          <div className="carousel-size pb-3 pt-3 ">
            <Carousel slides={slides} />
            {/* <!-- Overlay Image --> */}
            <img src={bannerlayout} alt="Overlay" class="layout" />
          </div>
          <div className="copy-rights py-6 text-center text-sm text-[#095228]">
            © 2025 Pipaan. All Rights Reserved
          </div>
        </div>

        {/* Right side login form */}
        <div className=" w-full lg:w-1/2 login-content flex flex-col">
          <div className="lg:hidden">
            <div className="carousel-size pb-3 pt-3 ">
              <Carousel slides={slidessm} />
              {/* <!-- Overlay Image --> */}
              <img src={bannerlayout} alt="Overlay" class="layout" />
            </div>
          </div>
          <div className="login-form">
            {/* Language selector */}
            <div className="flex justify-end">

              <Menu as="div" className="language-btn relative inline-block text-left">
                <div>
                  <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md px-3 py-2 text-sm align-center  hover:bg-gray-50">
                    English
                    <svg width="10" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12.92 0.179932H6.68999H1.07999C0.119992 0.179932 -0.360007 1.33993 0.319993 2.01993L5.49999 7.19993C6.32999 8.02993 7.67999 8.02993 8.50999 7.19993L10.48 5.22993L13.69 2.01993C14.36 1.33993 13.88 0.179932 12.92 0.179932Z" fill="#292D32" />
                    </svg>
                  </MenuButton>
                </div>

                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  <div className="py-1">
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >

                      </a>
                    </MenuItem>
                    <MenuItem>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                      >

                      </a>
                    </MenuItem>
                    <form action="#" method="POST">
                      <MenuItem>
                        <button
                          type="submit"
                          className="block w-full px-4 py-2 text-left text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                        >
                        </button>
                      </MenuItem>
                    </form>
                  </div>
                </MenuItems>
              </Menu>
            </div>

            {/* Right Side - Form Section */}
            <div className="reset-pass flex flex-col items-center justify-center px-6">
              {/* Logo */}
              <div className=" logo">
                <img
                  src={logo}
                  alt="Pipaan Logo"
                  width={150}
                  height={50}
                />
              </div>

              {/* Back to login */}
              <div className="w-full max-w-md">
                <Link to="/login" className="back-to-login text-500 text-sm flex items-center mb-4">
                  <svg
                    className="w-4 h-4 mr-1"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7"></path>
                  </svg>
                  Back to login
                </Link>

                {/* Title */}
                <h2 className="login-title text-2xl font-semibold text-left mb-2">Set A Password</h2>
                <p className="text-gray-500 text-sm text-left mb-10">
                  Your previous password has been reset. Please set a new password for your account.
                </p>
                {error && <p className="text-red-500 text-center mb-4">{error}</p>}

                {/* Password Input */}
                <form onSubmit={handleSubmit} className="space-y-4">

                  <div className="w-full relative mb-5 reset-pass-content">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Create Password"
                      value={password}
                      onChange={(e) => validatePassword(e.target.value)}
                      required
                      className="w-full h-12 px-4 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute right-4 top-1/2 transform -translate-y-1/2"
                    >
                      <img
                        src={showPassword ? eye : eyeslash}
                        alt="Toggle Password"
                        className="w-6 h-6"
                      />
                    </button>
                  </div>
                  {/* ✅ Password Criteria Display with Checkboxes */}
                  <div className="password-checkmar text-sm text-gray-600 mt-2 flex flex-wrap gap-x-6">
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        checked={passwordCriteria.minLength}
                        readOnly
                        className="w-4 h-4 accent-green-500"
                      />
                      <span className="">
                        Min 8 characters</span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        checked={passwordCriteria.alphanumeric}
                        readOnly
                        className="w-4 h-4 accent-green-500"
                      />
                      <span className="">Alphanumeric</span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        checked={passwordCriteria.specialChar}
                        readOnly
                        className="w-4 h-4 accent-green-500"
                      />
                      <span className="">
                        Special character</span>
                    </div>
                  </div>

                  {passwordError && <p className="text-red-500 text-sm mt-2">{passwordError}</p>}




                  {/* Confirm Password Input */}
                  <div className="w-full  relative mb-10 reset-pass-content">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      placeholder="Re-enter Password"
                      value={confirmPassword}
                      onChange={(e) => validateConfirmPassword(e.target.value)}
                      required
                      className="w-full h-12 px-4 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      className="absolute right-4 top-1/2 transform -translate-y-1/2"
                    >
                      <img
                        src={showConfirmPassword ? eye : eyeslash}
                        alt="Toggle Password"
                        className="w-6 h-6"
                      />
                    </button>
                  </div>
                  {/* Show Confirm Password Error */}
                  {confirmPasswordError && <p className="text-red-500 text-sm">{confirmPasswordError}</p>}

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={passwordError || confirmPasswordError || isSubmitting}
                    aria-busy={isSubmitting}
                    className={`w-full h-12 bg-black text-white rounded-xl font-medium ${passwordError || confirmPasswordError || isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
                  >
                    {isSubmitting ? 'Setting...' : 'Set Password'}
                  </button>
                </form>


                {/* Footer */}
                <div className="lg:hidden">

                  <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                    © 2025 Pipaan. All Rights Reserved
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
